import { SeeMoreBlock } from "@/components/blocks/SeeMoreBlock";
import { TagLink } from "@/components/widgets/TagList/TagLink";
import { FeedModuleTypeEnum, IGif, ITag } from "@/common/services/types";
import { routes } from "@/common/utils/routes";
import { metricsBus } from "@/common/buses";
import { useMemo } from "react";
import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";

interface IRelatedTagsProps {
  gifs: IGif[];
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

const TAGS_LIMIT = 15;

export const RelatedTags = ({ gifs, moduleId, moduleType }: IRelatedTagsProps) => {
  const tags = useMemo(() => {
    const items: { name: string; count: number }[] = [];

    gifs.forEach(gif => {
      if (!gif.tags) {
        return;
      }

      gif.tags.forEach(tag => {
        const index = items.findIndex((item) => item.name === tag);

        if (index === -1) {
          items.push({
            name: tag,
            count: 1,
          });
        } else {
          items[index].count++;
        }
      });
    });

    items.sort((a, b) => a.count - b.count);

    return items;
  }, [gifs]);

  const sendMetrics = (targetURL: string) => {
    metricsBus.emit("watchPageNavigation", { elementType: "Tag", targetURL });
  };

  if (!tags.length) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <SeeMoreBlock
        header="Related Tags"
        more={routes.trendingTags()}
        className="trendingTags canvas"
        list={true}
      >
        {tags.slice(0, TAGS_LIMIT).map((tag: ITag) => (
          <TagLink
            key={tag.name}
            tag={tag}
            counts={false}
            onClick={() => sendMetrics(routes.singleTag(tag.name))}
          />
        ))}
      </SeeMoreBlock>
    </FeedModuleContainer>
  );
};
